'use client';

import React from 'react';

import {ClpPrimaryCtaButton} from '@/features/course-landing-page/components/clp-primary-cta-button/clp-primary-cta-button.react-component';

import styles from './enrolled-sticky-footer-content.module.scss';

/**
 * EnrolledStickyFooterContent component displays only a CTA button for enrolled users.
 * This provides a simple action for users who are already enrolled in the course.
 */
export const EnrolledStickyFooterContent: React.FC = () => {
    return (
        <ClpPrimaryCtaButton className={styles['transactional-cta-button']} udStyle="primary" />
    );
};
